module.exports = __webpack_public_path__ + "static/media/geoSearch.2da2d4e8.svg";